import { observer } from 'mobx-react-lite';
import { useApiClient } from '~/api-client';
import { IconButton, Menu, MenuContent, MenuTrigger, MenuItem } from '@cad-arc';
import { useWorkspacePanel } from '../../panels/hooks/use-workspace-panel';
import { useCallback } from 'react';
import { EventResource } from '@mark43/cad-api';

export const ExternalAgencyEventKebabMenu = observer(function ExternalAgencyEventKebabMenu() {
    const eventId = useWorkspacePanel().linkedEntityId;
    const apiClient = useApiClient();
    const reRequestAssistance = useCallback(() => {
        if (!eventId) return;
        apiClient.request<EventResource.RetryExternalCallCopy>({
            method: 'POST',
            url: `event/copy/retry/${eventId}/`,
        });
    }, [apiClient, eventId]);
    return (
        <Menu>
            <MenuTrigger asChild>
                <IconButton
                    data-testid="other-options-menu"
                    variant="ghost"
                    icon="MoreActions"
                    aria-label="more actions"
                />
            </MenuTrigger>
            <MenuContent>
                <MenuItem
                    onSelect={() => {
                        reRequestAssistance();
                    }}
                >
                    Re-request Assistance
                </MenuItem>
            </MenuContent>
        </Menu>
    );
});
